export const tbdgRoutes = [
  {
    path: '/tbdg/create',
    name: 'TbdgCreate',
    component: () => import('@/views/tbdg/create/Create.vue'),
    meta: {
      title: '淘寶代採購'
    }
  },
  {
    path: '/tbdg/list',
    name: 'TbdgList',
    component: () => import('@/views/tbdg/list/List.vue'),
    meta: {
      title: '採購訂單',
      keepAlive: true
    }
  },
  {
    path: '/tbdg/detail/:id',
    name: 'TbdgDetail',
    component: () => import('@/views/tbdg/detail/Detail.vue'),
    meta: {
      title: '採購訂單明細'
    }
  },
  {
    path: '/tbdg/cart',
    name: 'TbdgCart',
    component: () => import('@/views/tbdg/cart/Cart.vue'),
    meta: {
      title: '採購車'
    }
  },
  {
    path: '/tbdg/createPreview',
    name: 'TbdgCreatePreview',
    component: () => import('@/views/tbdg/createPreview/CreatePreview.vue'),
    meta: {
      title: '確認訂單'
    }
  },
  {
    path: '/tbdg/cart/importTbCart',
    name: 'TbdgCartImportTbCart',
    component: () => import('@/views/tbdg/cart/ImportTbCart/ImportTbCart.vue'),
    meta: {
      title: '導入淘寶購物車'
    }
  },
  // {
  //   path: '/tbdg/profile',
  //   name: 'TbdgProfile',
  //   component: () => import('@/views/tbdg/profile/Profile.vue'),
  //   meta: {
  //     title: '我的'
  //   }
  // },
  {
    path: '/tbdg/offer/:id',
    name: 'TbdgOffer',
    component: () => import('@/views/tbdg/offer/Offer.vue'),
    meta: {
      title: '商品詳情'
    }
  },
  {
    path: '/tbdg/favorite',
    name: 'TbdgFavorite',
    component: () => import('@/views/tbdg/Favorite/List.vue'),
  },
  {
    path: '/tbdg/repurchase/:id',
    name: 'TbdgRepurchase',
    component: () => import('@/views/tbdg/repurchase/Repurchase.vue'),
    meta: {
      title: '再次購買'
    }
  },
]
